export default __webpack_public_path__ + "images/College-Lockups-for-Web_EHS0728919f-ef33-44f2-9815-580b18dd0cfe.svg";